export default "__VITE_ASSET__BiFOhWIC__"